import { createContext, useContext, useState } from 'react';

interface IBusinessContextData {
  page: number;
  setPage: (page: number) => void;
}

const BusinessContext = createContext({} as IBusinessContextData);

export const useBusinessContext = () => {
  return useContext(BusinessContext);
};

type Props = {
  children?: React.ReactNode,
};

export const BusinessProvider: React.FC<Props> = ({ children }) => {
  const [page, setPage] = useState(0);

  return (
    <BusinessContext.Provider value={{ page, setPage }}>
      {children}
    </BusinessContext.Provider>
  );
};
